import styled from 'styled-components'

export const HeadingWrapper = styled.div`
  margin-bottom: 25px;
  text-align: center;
`
